/*跨域地址*/
const dev = process.env.dev
const pay = process.env.pay
const rescApi = process.env.rescApi
const wxlogin = process.env.wxlogin

export default {
  //数字化获客赋能保存渠道浏览记录
  savePvDAC: {
    url: rescApi + '/dac/order/visit',
    method: 'post'
  },
  //对外接口_通过svProductId查询服务商品信息
  dyH5PayProduct: {
    url: dev + '/noauth/h5/pay/sv/product/detail',
    method: 'get'
  },

  // 微信H5支付 抖音投放
  payWxOrder: {
    url: pay + '/noauth/h5/wx/pay',
    method: 'post'
  },
  //微信环境 下单
  dyH5Pay: {
    url: rescApi + '/dac/order/pay',
    method: 'post'
  },
  //微信环境 下单（不需要验证码）
  dyH5NoSmsPay: {
    url: rescApi + '/dac/order/pay/no/sms',
    method: 'post'
  },
  //查询订单是否支付 抖音投放
  dyH5PayStatus: {
    url: rescApi + '/dac/order/pay/status',
    method: 'post'
  },
  //发送验证码
  getCGeeCode: {
    url: rescApi + '/noauth/sms/code',
    method: 'post'
  },
  //滑动验证码
  getCSmsCodeActivity: {
    url: rescApi + '/noauth/captcha',
    method: 'get'
  },
  /**获取用户信息 */
  getCustDetails: {
    url: rescApi + '/my/cust/details',
    method: "get"
  },
  //获取子渠道投放二维码
  createQrcodeBySubId: {
    url: wxlogin + '/noauth/wx/common/sub/qrcode',
    method: 'post'
  },
  //非微信环境H5支付下单
  unwxH5Pay: {
    url: dev + '/noauth/h5/pay',
    method: 'post'
  },
  //查询订单是否支付
  unwxH5PayStatus: {
    url: dev + '/noauth/h5/pay/order/status',
    method: 'post'
  },
  //推送顾问行为记录
  tsAagentBehavior: {
    url: dev + '/noauth/push/agent/behavior',
    method: 'post'
  }
};



// WEBPACK FOOTER //
// ./src/api/wxAcivity.js